/*
 *
 * Do not edit directly
 * Generated on Fri, 14 Feb 2025 18:58:13 GMT
 *
 */


const theme = {
  appearances: {
    feature: { type: 'variant', values: [ true ] },
    inverse: { type: 'variant', values: [ true ] },
    label: { type: 'variant', values: [ true ] },
    large: { type: 'variant', values: [ true ] },
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    {
      if: { viewport: [ 'xs' ] },
      tokens: {
        containerPaddingBottomTop: 16,
        containerPaddingLeftRight: 24,
        labelFontSize: 14,
        labelLineHeight: 1.4285714285714286,
        textLineHeight: 1.28571428571
      }
    },
    {
      if: { feature: true },
      tokens: {
        containerBorderColor: '#f39d80',
        labelLineHeight: 1.55555555,
        textFontSize: 72,
        textLineHeight: 1.2,
        textTimerFontName: 'SofiaPro',
        textTimerFontWeight: '700'
      }
    },
    {
      if: { large: true },
      tokens: {
        labelLineHeight: 1.55555555,
        textFontSize: 72,
        textLineHeight: 1.2,
        textTimerFontName: 'SofiaPro',
        textTimerFontWeight: '700'
      }
    },
    {
      if: { inverse: true },
      tokens: { containerBorderColor: '#ffffff', labelBorderColor: '#ffffff' }
    }
  ],
  tokens: {
    containerBorderColor: 'rgba(0, 0, 0, 0)',
    containerBorderRadius: 6,
    containerBorderWidth: 2,
    containerGradient: null,
    containerInverseBorder: 2,
    containerInverseBorderColor: '#ffffff',
    containerPaddingBottomTop: 48,
    containerPaddingLeftRight: 64,
    inverseBorderColor: 'rgba(0, 0, 0, 0)',
    labelBorderColor: '#394056',
    labelFontName: 'SofiaPro',
    labelFontSize: 18,
    labelFontWeight: '400',
    labelLineHeight: 1.5,
    textFontSize: 18,
    textLineHeight: 1.5,
    textTimerFontName: 'SofiaPro',
    textTimerFontWeight: '400'
  }
}
export default theme
